import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Item, ItemListParams } from "../models/item_model";
import { addToWishlist, getItemList, updateItem } from "../services/api_service";
import { primaryColor } from "../services/theme_service";
import { Footer } from "./components/footer";

import filterIcon from "../assets/icons/filter.png";
import heartIcon from "../assets/svg/heart_unselect.svg";
import minCartIcon from "../assets/svg/mini_cart.svg";

import { useMediaQuery } from "react-responsive";
import { Platform } from "react-native";

const SORT_OPTIONS = ["Price: High to Low", "Price: Low to High"];

export const ResultPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { masterProductId, headerTitle, isCelebrityChoice, search } = location.state || {};
  const [title, seTtitle] = useState(headerTitle || "");
  const [items, setItems] = useState<Item[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const userId = localStorage.getItem("userId") ?? undefined;

  const getHeaderTitle = () => {
    if (headerTitle) seTtitle(headerTitle);
    else if (search) seTtitle(search);
    else if (isCelebrityChoice) seTtitle("Celebrity Choice");
    else seTtitle("Top Rated");
  };

  const fetchItems = async (pageNum: number) => {
    if (loading || !hasMore) return;
    setLoading(true);
    setError(null);

    try {
      const params: ItemListParams = {
        page: pageNum,
        pageSize: 20,
        search,
        isCelebrityChoice,
        masterProductId,
        userId: userId
      };
      const response = await getItemList(params);

      if (response && response.records.length > 0) {
        setItems((prev) => (pageNum === 1 ? response.records : [...prev, ...response.records]));
        setTotalRecords(response.total_record_count);
        setHasMore(response.current_page < response.total_pages);
      } else {
        if (pageNum === 1) setItems([]);
        setHasMore(false);
      }
    } catch (err) {
      setError("Failed to load products. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setItems([]);
    setTotalRecords(0);
    setPage(1);
    setHasMore(true);
    fetchItems(1);
    getHeaderTitle();
  }, [masterProductId, isCelebrityChoice, location.search]);

  const loadMore = () => {
    if (!loading && hasMore) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchItems(nextPage);
    }
  };

 useEffect(() => {
  const handleScroll = () => {
    if (loading || !hasMore) return;

    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100) {
      loadMore();
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [loading, hasMore, items]);


  const goToProduct = (id: number) => navigate(`/details?id=${id}`);

  // -----------------------------
  // Web View
  // -----------------------------
  const renderWebView = () => (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <div style={styles.header}>
          <span style={styles.headerText}>Home / Collections / {title}</span>
        </div>
      </div>

      <div style={styles.filterRow}>
        <button style={styles.filterButton}>
          <img src={filterIcon} alt="Filter" style={{ width: 20, height: 20 }} />
        </button>
        {["Sarees under Rs 5000", "Featured", "Best Selling", "Party Wear", "Festive Sarees"].map(
          (label, idx) => (
            <button key={idx} style={styles.chip}>
              <span style={styles.chipText}>{label}</span>
            </button>
          )
        )}
      </div>

      <div style={styles.gridContainer} ref={scrollContainerRef}>
        <div style={styles.resultsRow}>
          <span style={styles.resultsText}>
            {items.length} of {totalRecords} Results
          </span>
          <div style={{ display: "flex", gap: 10, overflowX: "auto" }}>
            {SORT_OPTIONS.map((option) => {
              const isSelected = sortBy === option;
              return (
                <button
                  key={option}
                  onClick={() => {
                    setSortBy(option);
                    let sortedItems = [...items];
                    if (option === "Price: High to Low") sortedItems.sort((a, b) => b.final_price - a.final_price);
                    else if (option === "Price: Low to High") sortedItems.sort((a, b) => a.final_price - b.final_price);
                    setItems(sortedItems);
                  }}
                  style={{
                    ...styles.tabButton,
                    ...(isSelected ? styles.tabButtonSelected : styles.tabButtonUnselected),
                  }}
                >
                  <span style={isSelected ? styles.tabTextSelected : styles.tabTextUnselected}>
                    {option}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {items.length === 0 && loading && (
          <div style={styles.loadingContainer}>
            <span style={styles.loadingText}>Loading products...</span>
          </div>
        )}

        {!loading && items.length === 0 && (
          <div style={styles.emptyContainer}>
            <span style={styles.emptyText}>{error || "No products found"}</span>
          </div>
        )}

        <div style={styles.gridWeb}>
       {items.map((item) => (
 <div key={item.item_id} style={styles.itemCard} onClick={() => goToProduct(item.item_id)}>
  <div style={styles.itemImageContainer}>
    <img
      src={item.item_images[0]?.document_url}
      alt={item.title}
      style={styles.itemImage}
    />
    {/* Heart icon (top-right) */}
    {!item.is_added_to_wishlist && (

   <img
  src={item.is_added_to_wishlist ? undefined : heartIcon}
  alt="Wishlist"
  style={styles.heartIcon}
  onClick={async (e) => {
    e.stopPropagation();
    try {
      // Optimistic update
      setItems((prev) =>
        prev.map((i) =>
          i.item_id === item.item_id ? { ...i, is_added_to_wishlist: !i.is_added_to_wishlist } : i
        )
      );
if(userId) {
       addToWishlist(userId, item.item_id);
}
    } catch (err) {
     
      setItems((prev) =>
        prev.map((i) =>
          i.item_id === item.item_id ? { ...i, is_added_to_wishlist: item.is_added_to_wishlist } : i
        )
      );
    }
  }}
/>)},
{item.is_added_to_wishlist && (
  <span style={styles.heartEmoji}>❤️</span>
)}


    {/* Min cart icon (bottom-right) */}
    <img
      src={minCartIcon}
      alt="Add to Cart"
      style={styles.cartIcon}
      onClick={(e) => {
        e.stopPropagation();
        console.log("Add to cart clicked", item.item_id);
      }}
    />
  </div>

  <span style={styles.itemTitle}>{item.title}</span>

  {/* Rating Row */}
  <div style={styles.ratingRow}>
    <div style={styles.ratingBox}>
      <span style={styles.ratingText}>⭐ {item.rating || "4.5"}</span>
    </div>
    <span style={styles.styleNumber}>Style #{item.item_number || "12345"}</span>
  </div>

  <span style={styles.itemPrice}>
    ₹ {item?.final_price || ""}
  </span>
</div>

))}


        </div>

        {loading && page > 1 && (
          <div style={{ width: "100%", padding: 16, textAlign: "center" }}>
            <span style={{ color: primaryColor }}>Loading more products...</span>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );

  // -----------------------------
  // Mobile View
  // -----------------------------
  const renderMobileView = () => (
    <div style={mobileStyles.container}>
      <div style={{ ...mobileStyles.headerContainer, paddingLeft: 20 ,paddingRight: 20, paddingTop: 20, paddingBottom: 5, borderRadius: 8 }}>
        <div style={{ ...mobileStyles.header, borderRadius: 8 }}>
          <span style={mobileStyles.headerText}>Home / Collections / {title}</span>
        </div>
      </div>

      {/* Filters */}
      <div style={mobileStyles.mobileFilterRow}>
        <button style={mobileStyles.filterButton}>
          <img src={filterIcon} alt="Filter" style={{ width: 18, height: 18 }} />
        </button>
        {["Sarees under Rs 5000", "Featured", "Best Selling", "Party Wear", "Festive Sarees"].map(
          (label, idx) => (
            <button key={idx} style={mobileStyles.chip}>
              <span style={mobileStyles.chipText}>{label}</span>
            </button>
          )
        )}
      </div>
      {items.length === 0 && loading && (
  <div
    style={{
      backgroundColor: "#f5f5f5", // light grey
      margin: "20px auto",
      padding: "30px",
      borderRadius: "12px",
      textAlign: "center",
      width: "90%",
    }}
  >
    <span style={{ fontSize: 16, fontWeight: 500, color: "#666" }}>
      ⏳ Loading products...
    </span>
  </div>
)}

{/* Empty State */}
{!loading && items.length === 0 && (
  <div
    style={{
      backgroundColor: "#f5f5f5", // light grey
      margin: "20px auto",
      padding: "30px",
      borderRadius: "12px",
      textAlign: "center",
      width: "90%",
    }}
  >
    <span style={{ fontSize: 16, fontWeight: 500, color: "#666" }}>
      {error || "😕 No products found"}
    </span>
  </div>
)}


     {/* Product Grid */}
<div style={mobileStyles.gridContainer} ref={scrollContainerRef}>
  {items.map((item) => (
    <div
      key={item.item_id}
      style={mobileStyles.itemCard}
      onClick={() => goToProduct(item.item_id)}
    >
      <div style={{ position: "relative" }}>
        <div style={mobileStyles.itemImageContainer}>
          <img
            src={item.item_images[0]?.document_url}
            alt={item.title}
            style={mobileStyles.itemImage}
          />
        </div>

        {/* Heart icon / Emoji */}
        {!item.is_added_to_wishlist && (
          <img
            src={heartIcon}
            alt="Wishlist"
            style={mobileStyles.heartIcon}
            onClick={async (e) => {
              e.stopPropagation();
              try {
                // Optimistic update
                setItems((prev) =>
                  prev.map((i) =>
                    i.item_id === item.item_id
                      ? { ...i, is_added_to_wishlist: !i.is_added_to_wishlist }
                      : i
                  )
                );

                const { item_id, ...rest } = item;
                if(userId) {
                await addToWishlist(userId, item_id);
                }
              } catch (err) {
                setItems((prev) =>
                  prev.map((i) =>
                    i.item_id === item.item_id
                      ? { ...i, is_added_to_wishlist: item.is_added_to_wishlist }
                      : i
                  )
                );
              }
            }}
          />
        )}
        {item.is_added_to_wishlist && (
          <span style={mobileStyles.heartEmoji}>❤️</span>
        )}
      </div>

   <span style={mobileStyles.itemTitle}>
  {item.title.length > 68 ? item.title.substring(0, 68) + "..." : item.title}
</span>

      <div style={mobileStyles.ratingRow}>
        <div style={mobileStyles.ratingBox}>
          <span style={mobileStyles.ratingText}>⭐ {item.rating || "4.5"}</span>
        </div>
        <span style={mobileStyles.styleNumber}>#{item.item_number || "12345"}</span>
      </div>

      <span style={mobileStyles.itemPrice}>
        ₹ {item?.final_price || ""}
      </span>
    </div>
  ))}
</div>
{loading && page > 1 && (
  <div style={{ width: "100%", padding: 16, textAlign: "center" }}>
    <span style={{ color: primaryColor }}>Loading more products...</span>
  </div>
)}

<div style={{height: 10}}></div>
      <Footer />
    </div>
  );

  return isMobile ? renderMobileView() : renderWebView();
};

// -----------------------------
// Web Styles
// -----------------------------
const styles: { [key: string]: React.CSSProperties } = {
  container: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "Arimo, sans-serif", backgroundColor: "#fff" },
  headerContainer: { backgroundColor: "#fff", overflow: "hidden" },
  header: { backgroundColor: "#693B2F", padding: "19px 0" },
  headerText: { color: "#fff", fontSize: 16, fontWeight: 500, margin: "0 10%" },
  filterRow: { display: "flex", alignItems: "center", justifyContent: "flex-start", padding: "8px 10%", marginTop: 12, marginBottom: 16, overflowX: "auto", gap: 8 },
  filterButton: { border: "1px solid #ccc", borderRadius: 10, padding: "8px 15px", backgroundColor: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  chip: { border: "1px solid #ccc", borderRadius: 10, padding: "8px 16px", backgroundColor: "#fff", cursor: "pointer", fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center" },
  chipText: { fontSize: 16, color: "#333" },


heartEmoji: {
  position: "absolute",
  top: 8,
  right: 8,
  fontSize: 20,
  cursor: "pointer",
},

gridContainer: { 
  display: "flex", 
  flexDirection: "column", 
  backgroundColor: "#F8E6E6", 
  borderRadius: 20, 
  margin: "0 10%", 
  marginBottom: "2%", 
  padding: 16, 
  gap: 16, 
},  resultsRow: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 },
  resultsText: { fontSize: 17, fontWeight: 600, color: "#333", marginLeft: 10 },
  tabButton: { borderRadius: 25, padding: "6px 16px", borderWidth: 2, borderStyle: "solid", cursor: "pointer" },
  tabButtonSelected: { borderColor: primaryColor, backgroundColor: primaryColor },
  tabButtonUnselected: { borderColor: "#ccc", backgroundColor: "#fff" },
  tabTextSelected: { color: "#fff", fontSize: 15 },
  tabTextUnselected: { color: "#000", fontSize: 15 },
  loadingWrapper: { width: "100%", display: "flex", justifyContent: "center" },
  loadingContainer: { backgroundColor: "#ffe6f0", borderRadius: 12, padding: "10px 20px", display: "inline-block" },
  loadingText: { color: "#d63384", fontWeight: 500 },
  emptyContainer: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 },
  emptyText: { fontSize: 16, color: "#777" },
  gridWeb: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, width: "100%" },
  itemCard: { cursor: "pointer", backgroundColor: "#fff", borderRadius: 12, display: "flex", flexDirection: "column", height: "60vh", overflow: "hidden" },
itemImageContainer: { 
  flex: 1, 
  overflow: "hidden", 
  borderRadius: 12, 
  position: "relative" // important for absolute icons
},
heartIcon: {
  position: "absolute",
  top: 8,
  right: 8,
  width: 35,
  height: 35,
  cursor: "pointer",
},
cartIcon: {
  position: "absolute",
  bottom: 8,
  right: 8,
  width: 35,
  height: 35,
  cursor: "pointer",
},
ratingRow: { 
  display: "flex", 
  alignItems: "center", 
  gap: 8, 
  padding: "0 8px", 
  marginBottom: 6 
},
ratingBox: { 
  backgroundColor: "#E8F4FF", 
  borderRadius: 6, 
  padding: "2px 6px" 
},
ratingText: { 
  fontSize: 13, 
  fontWeight: 500, 
  color: "#0077CC" 
},
styleNumber: { 
  fontSize: 13, 
  color: "#777" 
},
  itemImage: { width: "100%", height: "100%", borderRadius: 12 },
  itemTitle: { marginTop: 5, fontSize: 17, fontWeight: 500, color: "#111", padding: "0 8px", marginBottom: 5 },
  itemPrice: { fontSize: 17, fontWeight: 700, color: "#111", padding: "0 8px", marginBottom: 9, marginTop: 5 },
};

// -----------------------------
// Mobile Styles
// -----------------------------
const mobileStyles: { [key: string]: React.CSSProperties } = {
  container: { display: "flex", flexDirection: "column", fontFamily: "Arimo, sans-serif", backgroundColor: "#fff", minHeight: "100vh" },
  headerContainer: { backgroundColor: "#fff", overflow: "hidden" },
  header: { backgroundColor: "#693B2F", padding: "20px 0" },
  headerText: { color: "#fff", fontSize: 14, fontWeight: 500, margin: "0 5%" },
 mobileFilterRow: { 
  display: "flex", 
  overflowX: "auto", 
  padding: "4px 5%", 
  gap: 6, 
  marginBottom: 10, 
  marginTop: 10 ,
  scrollbarWidth: "none",
},
filterButton: { 
  border: "1px solid #ccc", 
  borderRadius: 8, 
  padding: "6px 10px", 
  backgroundColor: "#fff", 
  cursor: "pointer", 
  display: "flex", 
  alignItems: "center", 
  justifyContent: "center",
  whiteSpace: "nowrap" // Prevent wrapping, allow full text
},
ratingRow: { 
  display: "flex", 
  alignItems: "center", 
  gap: 6, 
  margin: "8px 0px" 
},
ratingBox: { 
  backgroundColor: "#E8F4FF", 
  borderRadius: 6, 
  padding: "2px 6px", 
  display: "inline-block" 
},
ratingText: { fontSize: 14, fontWeight: 500, color: "#111" },
styleNumber: { fontSize: 14, color: "#777" },
heartIcon: {
  position: "absolute",
  top: 6,
  right: 6,
  width: 26,
  height: 26,
  cursor: "pointer",
  zIndex: 2,
},
heartEmoji: {
  position: "absolute",
  top: 6,
  right: 6,
  fontSize: 18,
  zIndex: 2,
},

chip: { 
  border: "1px solid #ccc", 
  borderRadius: 8, 
  padding: "6px 10px", 
  backgroundColor: "#fff", 
  cursor: "pointer", 
  fontWeight: 500, 
  display: "flex", 
  alignItems: "center", 
  justifyContent: "center",
  whiteSpace: "nowrap" // Keep text in one line
},
chipText: { 
  fontSize: 14, 
  color: "#333",
  whiteSpace: "nowrap" // Prevent text from wrapping
},

gridContainer: { 
  display: "grid", 
  gridTemplateColumns: "1fr 1fr", 
  gap: 10, 
  padding: "0 5%", 
},  

itemCard: { cursor: "pointer", backgroundColor: "#fff", borderRadius: 12, display: "flex", flexDirection: "column", overflow: "hidden" },
  itemImageContainer: { flex: 1, 
 overflow: "hidden", borderRadius: 12, flexShrink: 0 },
  itemImage: { width: "100%", minHeight: "40vh", borderRadius: 12,  objectFit: "cover",  display: "block" },
  itemTitle: { marginTop: 4, fontSize: 14, fontWeight: 500, color: "#111", padding: "0 4px", marginBottom: 2 },
  itemPrice: { fontSize: 14, fontWeight: 700, color: "#111", padding: "0 4px", marginBottom: 4 },
  emptyContainer: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 100 },
  emptyText: { fontSize: 14, color: "#777" },
};